module.exports = __webpack_public_path__ + "static/media/banknote-15.ce9aa870.svg";